import { ChangeDetectionStrategy, Component, OnInit, output } from '@angular/core';
import { DepositTranslatePipe } from '@fitness-force/pipes/common-pipes';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'no-deposit',
  templateUrl: './no-deposit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, DepositTranslatePipe]
})
export class NoDepositComponent implements OnInit {
  readonly onAction = output<{ action: string }>();
  constructor() { }

  ngOnInit(): void {
  }

  addDepositModal()
  {
    this.onAction.emit({ action: "createdeposit" });
  }

}